import { useSrpContext } from '@/src/contexts'

import PageIntro from './pageIntro'

const PageIntroWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()

    const pageIntro = sections?.pageIntro
    if (!pageIntro?.paragraphs?.length) return null

    return (
        <PageIntro
            heading={pageIntro.heading}
            paragraphs={pageIntro.paragraphs}
        />
    )
}

export default PageIntroWrapper
